<article class="project-details-version-list" >
  <ul class="related-version-list" *ngIf="relateds != null">
    <li *ngFor="let group of relateds; let groupIndex = index;" class="related-version-li">
      <div class="related-version-list-item">
        <core-versions-related-group-item-list
          [related]="group"
          [project]="project"
          [opened]="isDisplayed(groupIndex)"
          (onClickOpen)="onClickGroup($event, groupIndex)"
        ></core-versions-related-group-item-list>
        <div [hidden]="!isDisplayed(groupIndex)">
            <project-details-versions-relateds-list-versions
                [related]="group"
                [project]="project"
            ></project-details-versions-relateds-list-versions>
        </div>
      </div>
    </li>
  </ul>
  <div [hidden]="status != STATUS_DONE">
    <div class="uploaded-tip" [hidden]="relateds == null || relateds.length == 0">
      <p><em></em><span>Artworks uploaded from this project</span></p>
    </div>
    <div class="message-not-content" [hidden]="relateds == null || relateds.length > 0 ">
      <core-helpers-box-alert-message-icon
        [text]="'There are no Artworks linked to this project yet.'"
        [icon]="'no_linked'"
      ></core-helpers-box-alert-message-icon>
    </div>
  </div>
</article>
